import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { NguiMapModule } from '@ngui/map';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './user/user.component';
import { SignMessRequestsComponent } from './requests/sign-mess-requests.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { DmsControlComponent } from './dms-control/dms-control.component';
import { FormsModule } from '@angular/forms';
import { PagePreviewComponent } from 'app/page-preview/page-preview.component';
import { PageMessageComponent } from 'app/page-message/page-message.component';
import { DisplayComponent } from './display/display.component';
import { SignComponent } from './display/display-section/sign/sign.component';
import { DisplaySectionComponent } from './display/display-section/display-section.component';

//<primeng imports>
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	InputTextModule,
	ButtonModule,
	DialogModule,
	DataTableModule,
	SharedModule,
	AccordionModule,
	MenuItem
} from 'primeng/primeng';
import {
	ConfirmDialogModule,
	ConfirmationService,
	OverlayPanelModule,
	MultiSelectModule
} from 'primeng/primeng';
import { RadioButtonModule, TabViewModule, CodeHighlighterModule } from 'primeng/primeng';
import { DropdownModule, ListboxModule, CheckboxModule, CalendarModule } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
//</primeng imports>

import { SignPrioritiesService } from 'services/sign-priorities/sign-priorities.service';
import { HttpModule } from '@angular/http';
import { FontsService } from 'services/fonts/fonts.service';
import { SignMessRequestsService } from 'services/signMessRequests/sign-mess-requests.service';
import { MultiSelectListComponent } from './multi-select-list/multi-select-list.component';
import { SignInfoService } from 'services/sign-info/sign-info.service';

import { BadWordsService } from 'services/bad-words/bad-words.service';
import { SignInputValidatorDirective } from 'app/directives/sign-input-validator/sign-input-validator.directive';
import { AuthService } from 'services/auth/auth.service';
import { AuthGuard } from 'services/auth/auth-guard.service';
import { AdminAuthGuard } from 'services/auth/admin-auth-guard.service';
import { LoginComponent } from 'app/login/login.component';
import { DmslogComponent } from './dmslog/dmslog.component';
import { MessageSignLogsService } from 'services/messageSignLogs/message-sign-logs.service';
import { StatusNamesService } from 'services/statusNames/status-names.service';
import { NoAccessComponent } from 'app/no-access/no-access.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { UserIdleService } from 'services/user-idle/user-idle.service';
import { UserInfoService } from 'services/user-info/user-info.service';

// import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
import { ActivityLogService } from 'services/activity-log/activity-log.service';
import { ActivityLogComponent } from './activity-log/activity-log.component';
import { WeightStationControlComponent } from './weight-station-control/weight-station-control.component';
import { WeightStationSignComponent } from './display/weight-station-sign/weight-station-sign.component';
import { WeightStationService } from 'services/weight-station/weight-station.service';
import { UserListComponent } from './user-list/user-list.component';

// const config: SocketIoConfig = { url: 'https://notif-server.azurewebsites.net/', options: {} };
// const config: SocketIoConfig = { url: 'http://localhost:3000/', options: {} };

@NgModule({
	declarations: [
		AppComponent,
		DashboardComponent,
		UserComponent,
		SignMessRequestsComponent,
		ActivityLogComponent,
		TypographyComponent,
		IconsComponent,
		MapsComponent,
		NotificationsComponent,
		UpgradeComponent,
		DmsControlComponent,
		PagePreviewComponent,
		PageMessageComponent,
		DisplayComponent,
		SignComponent,
		DisplaySectionComponent,
		MultiSelectListComponent,
		SignInputValidatorDirective,
		LoginComponent,
		DmslogComponent,
		NoAccessComponent,
		ConfirmDialogComponent,
		UserListComponent,
		WeightStationControlComponent,
		WeightStationSignComponent
	],
	imports: [
		//<primeng>
		InputTextModule,
		ButtonModule,
		DialogModule,
		DataTableModule,
		SharedModule,
		AccordionModule,
		ConfirmDialogModule,
		OverlayPanelModule,
		MultiSelectModule,
		RadioButtonModule,
		TabViewModule,
		CodeHighlighterModule,
		SliderModule,
		//</primeng>

		BrowserModule,
		RouterModule.forRoot(AppRoutes),
		SidebarModule,
		NavbarModule,
		FooterModule,
		FixedPluginModule,
		FormsModule,
		DropdownModule,
		AccordionModule,
		BrowserAnimationsModule,
		ListboxModule,
		CheckboxModule,
		RadioButtonModule,
		SharedModule,
		InputTextModule,
		ButtonModule,
		CalendarModule,
		HttpModule,
		NguiMapModule.forRoot({
			apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyBr-tgUtpm8cyjYVQDrjs8YpZH7zBNWPuY'
		})
		//commented until we have our socket server
		// SocketIoModule.forRoot(config)
	],
	providers: [
		SignPrioritiesService,
		FontsService,
		SignMessRequestsService,
		SignInfoService,
		AuthService,
		BadWordsService,
		AuthGuard,
		AdminAuthGuard,
		MessageSignLogsService,
		StatusNamesService,
		UserIdleService,
		UserInfoService,
		ActivityLogService,
		WeightStationService,
		//<primeng>
		ConfirmationService
		//</primeng>
	],
	bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/app.module.ts